module.exports = __webpack_public_path__ + "static/media/RecomendaIntermediarioElite.251a4bf9.png";